import { getToken } from "@/libs/util";
import { apis } from '@/api/order/createB2BToB2C.js'
import Goods from './goods.vue'
export default function () {
  let api = (name, data) => {
    if (!apis[name]) return console.log(name, '接口不存在')
    return new Promise((resolve, reject) => {
      apis[name](data).then(res => {
        if (res.data.status) {
          resolve(res.data)
        } else {
          this.$Message.error({
            content: res.data.msg,
          })
          reject(res.data)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }

  const changeCountry = ({ formData, fields, value, init }) => {
    !init && (formData.destCode = '')
    if (value) {
      api('city', { country_code: value }).then(res => {
        fields.find(item => item.key === 'destCode').options = res.payload.rows.map(item => {
          return {
            label: item.title,
            value: item.title
          }
        })
      })
    } else {
      fields.find(item => item.key === 'destCode').options = []

    }
  }

  const getChannel = ({ formData }) => {
    console.log('chufa', formData);
    if (formData.fromCountry && formData.country) {
      api('channel', {
        fromCountry: formData.fromCountry,
        targetCountry: formData.country,
        transportCode: "1",
      }).then(res => {
        formData.transportMode = res.payload.rows[0].channel_code
        console.log(formData);
      })
    }

  }

  const config = {
    submit: (formData) => {
      formData = Object.assign({}, formData, {
        transportMode: this.$refs['form'].formData.transportMode,
      })
      formData.cargoInfo = Object.assign({}, formData.cargoInfo, {
        packageType: "XPS",
        unbox: "NO",
      })
      api('create', formData).then(res => {
        this.$Message.success({
          content: res.msg,
          duration: 3,
          background: true
        })
        this.$refs['form'].clear()
      })
    },
    config: {
      formBind: {
        labelWidth: 100,
        disabled() {
          return this.$modal && this.$modal.type === 'detail'
        }
      },
      rowBind: {
        gutter: 16,
      },
      colBind: {
        style: {
          marginBottom: "20px"
        }
      },
      rules: {
        b2b_awb: [{ required: true, message: "cannot be empty", trigger: "blur" }],
        service: [{ required: true, message: "cannot be empty", trigger: "blur" }],
        ncndAmt: [{ required: true, message: "cannot be empty", trigger: "blur", type: 'number' }],
        noofPieces: [{ required: true, message: "cannot be empty", trigger: "blur", }],
        weight: [{ required: true, message: "cannot be empty", trigger: "blur", type: 'number' }],
        company: [{ required: true, message: "cannot be empty", trigger: "blur" }],
        contact: [{ required: true, message: "cannot be empty", trigger: "blur" }],
        fromCountry: [{ required: true, message: "cannot be empty", trigger: "blur" }],
        country: [{ required: true, message: "cannot be empty", trigger: "blur" }],
        destCode: [{ required: true, message: "cannot be empty", trigger: "blur" }],
        tel: [{ required: true, message: "cannot be empty", trigger: "blur" }],
        address: [{ required: true, message: "cannot be empty", trigger: "blur" }],
      }
    },
    grid: [
      { b2b_awb: 6 },
      {
        name: this.$tz('订单信息'),
        key: 'cargoInfo',
        children: [
          { shipperRef: 6, service: 6, ncndAmt: 6, noofPieces: 6, weight: 6, remark: 12 }
        ]
      },
      {
        name: this.$tz('收件人信息'),
        key: 'consigneeInfo',
        children: [
          { company: 6, contact: 6, fromCountry: 6, country: 6, destCode: 6, tel: 6, mobile: 6, consignee_email: 6, area: 6, address: 12 }
        ]
      },
      {
        name: this.$tz('货物信息'),
        children: [
          { invoiceInfo: 24 }
        ]
      }
    ],
    fields: [
      {
        name: () => this.$tz('B2B订单号'),
        key: 'b2b_awb',
        component: 'Input',
        bind: {
          search: true,
          enterButton: true
        },
        placeholder: () => this.$tz('B2B订单号'),
        methods: {
          'on-search'({ value, fields, formData }) {
            api('detail', { id: value }).then(res => {
              this.$form.setFormData(Object.assign(fields.reduce((a, b) => {
                a[b.key] = res.payload[b.dataKey || b.key]
                if (b.component === 'InputNumber') a[b.key] = Number(a[b.key])
                return a
              }, {}), { b2b_awb: value, fromCountry: res.payload.to_country }))
              changeCountry({
                init: true,
                formData: this.$form.formData, fields, value: this.$form.formData.country
              })
              getChannel({ formData: this.$form.formData })
            })
          },
        }
      },
      {
        key: 'invoiceInfo',
        render(h, p) {
          if (!p.row.invoiceInfo) p.row.invoiceInfo = []
          return h(Goods, {
            attrs: {
              list: p.row.invoiceInfo
            }
          })
        },
        formItemBind: {
          labelWidth: 0
        }
      },
      {
        name: () => this.$tz('客户单号'),
        key: 'shipperRef',
        component: 'Input',
        deep: false,
        placeholder: () => this.$tz('客户单号'),
      },
      {
        name: this.$tz('货款代收'),
        key: 'service',
        dataKey: 'cod_type',
        component: 'Radio',
        placeholder: () => this.$tz('货款代收'),
        bind: {
          border: true
        },
        options: [
          { label: this.$tz('是'), value: 'NCND' },
          { label: this.$tz('否'), value: 'NOR' },
        ],
        optionsFn: '',
        optionsKey: '',
        default: 'NOR',
      },
      {
        name: this.$tz('代收金额'),
        key: 'ncndAmt',
        dataKey: 'cod_amount',
        component: 'InputNumber',
        default: 0,
        bind: {
          border: true,
          min: 0,
          step: 0.01,
          style: 'width:100%'
        },
      },
      {
        name: () => this.$tz('包裹件数'),
        key: 'noofPieces',
        dataKey: 'quantity',
        component: 'Input',
        placeholder: () => this.$tz('包裹件数'),
        default: '1',
        // disabled: true,
      },
      {
        name: this.$tz('订单,毛重'),
        key: 'weight',
        dataKey: 'claim_weight',
        component: 'InputNumber',
        default: 0,
        bind: {
          border: true,
          min: 0,
          step: 0.01,
          style: 'width:100%'
        },
      },
      {
        key: 'remark',
        name: () => this.$tz('备注'),
        placeholder() {
          return this.$tz('备注');
        },
        dataKey: 'remarks',
        deep: false,
        component: 'Input',
        bind: {
          type: 'textarea',
          autosize: { minRows: 2 },
        },
      },
      {
        name: () => this.$tz('收件公司'),
        key: 'company',
        dataKey: 'consignee',
        component: 'Input',
        placeholder: () => this.$tz('收件公司'),
      },
      {
        name: () => this.$tz('收件人姓名'),
        key: 'contact',
        dataKey: 'consignee_contact',
        component: 'Input',
        placeholder: () => this.$tz('收件人姓名'),
      },
      {
        name: this.$tz('起运国家'),
        key: 'fromCountry',
        component: 'Select',
        dataKey: 'from_country',
        placeholder: () => this.$tz('起运国家'),
        options: [],
        optionsFn: 'formCountry',
        config: {
          label: 'title'
        },
        optionsKey: '',
        default: '',
        methods: {
          'on-change'({ formData }) {
            getChannel({ formData })
          }
        }
      },
      {
        name: this.$tz('目的国家'),
        key: 'country',
        dataKey: 'to_country',
        component: 'Select',
        placeholder: () => this.$tz('目的国家'),
        options: [],
        config: {
          label: 'title'
        },
        optionsFn: 'toCountry',
        optionsKey: '',
        default: '',
        methods: {
          'on-change'({ value, fields, formData }) {
            changeCountry({ formData, fields, value })
            getChannel({ formData })
          }
        }
      },
      {
        name: this.$tz('城市名称'),
        key: 'destCode',
        dataKey: 'city_name',
        component: 'Select',
        placeholder: () => this.$tz('城市名称'),
        options: [],
        optionsFn: '',
        optionsKey: '',
        default: '',
      },
      {
        name: () => this.$tz('收件人电话'),
        key: 'tel',
        dataKey: 'consignee_cellular',
        component: 'Input',
        placeholder: () => this.$tz('收件人电话'),
      },
      {
        name: () => this.$tz('收件人电话,2'),
        key: 'mobile',
        dataKey: 'consignee_telephone',
        component: 'Input',
        placeholder: () => this.$tz('收件人电话,2'),
      },
      {
        name: () => this.$tz('邮箱'),
        key: 'consignee_email',
        component: 'Input',
        placeholder: () => this.$tz('邮箱'),
      },
      {
        name: () => this.$tz('区域'),
        key: 'area',
        component: 'Input',
        placeholder: () => this.$tz('区域'),
      },
      {
        key: 'address',
        dataKey: 'consignee_address',
        name: () => this.$tz('收货地址'),
        placeholder() {
          return this.$tz('收货');
        },
        component: 'Input',
        bind: {
          type: 'textarea',
          autosize: { minRows: 2 },
        },
      },
    ]
  }
  return config
}